module.exports = new __parcel__URL__("shop_machines_space_elixir_accelerator.5da1e61c.png").toString();